<ng-container *transloco="let t">
  <div class="container pt-32-15 pb-300-100">
    <div class="d-flex mb-4">
      <h2 class="me-3">{{ league?.name }}</h2>
      <div class="d-flex action-btn-wrapper">
        <img src="assets/icons/icons-alt/share-alt.svg" alt="Podijeli">
      </div>
    </div>

    <h3>{{ t('league.tab.feeds') }}</h3>
  </div>
</ng-container>
